import { Modal, Box, Typography, Button, Paper } from "@mui/material";
import React, { useState, useMemo } from "react";
import MUIDataTable from "mui-datatables";
import { CircularProgress } from "@mui/material";

const ArchiveHistoryMetadataModal = ({
  open,
  handleClose,
  data,
  isLoading,
  style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxHeight: "80vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    overflow: "auto",
  },
}) => {
  console.log(data);
  // Dynamically generate columns based on data
  const columns = useMemo(() => {
    if (!data || data.length === 0) return [];

    // Extract keys from the first data object
    const keys = Object.keys(data[0]);

    return keys.map((key) => ({
      name: key,
      label: key
        .replace(/([A-Z])/g, " $1") // Add space before capital letters
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/^./, (str) => str.toUpperCase()), // Capitalize first letter
      options: {
        filter: true,
        sort: true,
        // Special formatting for certain types of data
        customBodyRender: (value) => {
          // Format date objects
          if (value instanceof Date) {
            return value.toLocaleString();
          }
          // Format boolean values
          if (typeof value === "boolean") {
            return value ? "Yes" : "No";
          }
          // Handle null/undefined values
          if (value === null || value === undefined) {
            return "N/A";
          }
          // Convert objects to JSON string
          if (typeof value === "object") {
            return JSON.stringify(value);
          }
          return value;
        },
      },
    }));
  }, [data]);

  const options = {
    filterType: "checkbox",
    responsive: "standard",
    selectableRows: "none",
    print: false,
    download: false,
    viewColumns: false,
    filter: true,
    search: true,
    pagination: true,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Archive History Additional Data
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            {data && data.length > 0 ? (
              <MUIDataTable data={data} options={options} columns={columns} />
            ) : (
              <Typography variant="body1" sx={{ p: 2 }}>
                No data available
              </Typography>
            )}
          </Paper>
        )}

        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ArchiveHistoryMetadataModal;
